import { ConnectorProps } from '../props/shape/connector-props';
import { ConnectorStore } from '../store/connector-store';
import { ConnectorMutationAPI } from '../api/connector-mutaiton-api';
import { BaseShapeDataModel } from './base-shape-data-model';
import type { PageContext } from '../context/page-context';
import type { IEventManager } from '../manager/event-manager';
import type { IConnectorData } from '../data/shape-data';
import type { IConnectorProps } from '../props/shape/connector-props';
import type { RestrictedDataModel } from './data-model';
import type { GroupShapeDataModel } from './group-shape-data-model';

export class ConnectorDataModel extends BaseShapeDataModel<IConnectorData> {
    public props: IConnectorProps;
    public store: ConnectorStore;
    public api: ConnectorMutationAPI;

    public constructor(
        data: IConnectorData,
        events: IEventManager,
        context: PageContext,
        public parent: GroupShapeDataModel,
    ) {
        super(events, context);

        this.store = new ConnectorStore(data, events, this);
        this.props = new ConnectorProps(this.store.data, this.context);
        this.api = new ConnectorMutationAPI(this, events);
    }
}

export { IConnectorProps };
export type IConnectorDataModel = RestrictedDataModel<ConnectorDataModel>;
